import { createSelector } from 'reselect';

const selectDigitalPublicInfrastructures = (state: any) => state.digitalPublicInfrastructures;


export const selectDigitalPublicInfrastructuresCurrentItem = createSelector([selectDigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.current);

export const selectDigitalPublicInfrastructuresListItems = createSelector([selectDigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectDigitalPublicInfrastructuresListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDigitalPublicInfrastructuresQueryItems = createSelector([selectDigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.query);

export const selectDigitalPublicInfrastructuresCreatedItem = createSelector([selectDigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.create);

export const selectDigitalPublicInfrastructuresUpdatedItem = createSelector([selectDigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.update);

export const selectDigitalPublicInfrastructuresReadItem = createSelector([selectDigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.read);

export const selectDigitalPublicInfrastructuresDeletedItem = createSelector([selectDigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.delete);

export const selectDigitalPublicInfrastructuresSearchedItems = createSelector([selectDigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.search);

export const selectDigitalPublicInfrastructuresItemsCount = createSelector([selectDigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.count);

export const selectDigitalPublicInfrastructuresItemsFilter = createSelector([selectDigitalPublicInfrastructures], (digitalPublicInfrastructures) => digitalPublicInfrastructures.filter);